module.exports = __webpack_public_path__ + "img/result_desktop.ea0af273.jpg";